import React from 'react'
import { Col, Container } from 'reactstrap'
import '../css/EditCreate.css';
import RefundedGiftReport from './RefundedGiftReport';
import PromoCodeUsageReport from './PromoCodeUsageReport'
import RedemptionCodeUsageReport from './RedemptionCodeUsageReport'
import ContactUsSubmissionsReport from './ContactUsSubmissionsReport'
import ReportTypes from './reportTypes'
import SalesReport from './SalesReport';
import RequiredFieldNotation from '../utils/RequiredFieldNotation';
import EnrolledGiftsReport from './EnrolledGiftsReport';
import CrossTerritorySalesReport from './CrossTerritorySalesReport';

const DATE_NOTE = "Dates are stored in GMT/UTC, but the report output converts to the local time zone of each branch club. To include records enrolled through a certain date local time, set the End Date to +1 day to compensate for the UTC/GMT time difference (Example: if you want transactions through EOD June 30, set the End date to July 1.)";
class GiftReport extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            report: props.route?.location?.state?.report ?? ReportTypes.SalesReport,
        }
    }

    reportHandler = e => this.setState({ report: e.target.value })

    handleCancel = _ => this.props.route.history.goBack()

    render() {
        return <Container>
            <div className="card">
                <div className="card-header text-center">Reports</div>
                <div className="card-body fs-12">
                    <RequiredFieldNotation />
                    <div className="row">
                        <div className="col-md-6">
                            <Col>
                                <div className="form-check mt-3">
                                    <label>
                                        <input
                                            name="sales"
                                            value={ReportTypes.SalesReport}
                                            className="input-radio-editable"
                                            type="radio"
                                            checked={this.state.report === ReportTypes.SalesReport}
                                            onChange={this.reportHandler} />
                                        <strong>Sales Report</strong>
                                    </label>
                                </div>
                                <div className="form-check mt-3">
                                    <label>
                                        <input
                                            name="enrolledGifts"
                                            value={ReportTypes.EnrolledGiftsReport}
                                            className="input-radio-editable"
                                            type="radio"
                                            checked={this.state.report === ReportTypes.EnrolledGiftsReport}
                                            onChange={this.reportHandler} />
                                        <strong>Enrolled Gifts Report</strong>
                                    </label>
                                </div>
                                <div className="form-check mt-3">
                                    <label>
                                        <input
                                            name="refundedGift"
                                            value={ReportTypes.RefundedGiftReport}
                                            className="input-radio-editable"
                                            type="radio"
                                            checked={this.state.report === ReportTypes.RefundedGiftReport}
                                            onChange={this.reportHandler} />
                                        <strong>Expired/Refunded Gift Report</strong>
                                    </label>
                                </div>
                                <div className="form-check mt-3">
                                    <label>
                                        <input
                                            name="promoCodeUsage"
                                            value={ReportTypes.PromoCodeUsageReport}
                                            className="input-radio-editable"
                                            type="radio"
                                            checked={this.state.report === ReportTypes.PromoCodeUsageReport}
                                            onChange={this.reportHandler} />
                                        <strong>Promo Code Usage Report</strong>
                                    </label>
                                </div>
                                <div className="form-check mt-3">
                                    <label>
                                        <input
                                            name="contact"
                                            value={ReportTypes.ContactUsSubmissionsReport}
                                            className="input-radio-editable"
                                            type="radio"
                                            checked={this.state.report === ReportTypes.ContactUsSubmissionsReport}
                                            onChange={this.reportHandler} />
                                        <strong>Contact Us Submissions Report</strong>
                                    </label>
                                </div>
                                <div className="form-check mt-3">
                                    <label>
                                        <input
                                            name="crossTerritory"
                                            value={ReportTypes.CrossTerritorySalesReport}
                                            className="input-radio-editable"
                                            type="radio"
                                            checked={this.state.report === ReportTypes.CrossTerritorySalesReport}
                                            onChange={this.reportHandler} />
                                        <strong>Cross-Territory Sales Summary Report</strong>
                                    </label>
                                </div>
                                <div className="form-check mt-3">
                                    <p className="date_note"><strong>Note: </strong>{DATE_NOTE}</p>
                                </div>
                            </Col>
                        </div>
                        <div className="col-md-6">
                            {this.state.report === ReportTypes.RefundedGiftReport
                                && <RefundedGiftReport handleCancel={this.handleCancel} />}
                            {this.state.report === ReportTypes.SalesReport
                                && <SalesReport handleCancel={this.handleCancel} />}
                            {this.state.report === ReportTypes.PromoCodeUsageReport
                                && <PromoCodeUsageReport handleCancel={this.handleCancel} />}
                            {this.state.report === ReportTypes.RedemptionCodeUsageReport
                                && <RedemptionCodeUsageReport handleCancel={this.handleCancel} />}
                            {this.state.report === ReportTypes.ContactUsSubmissionsReport
                                && <ContactUsSubmissionsReport handleCancel={this.handleCancel} />}
                            {this.state.report === ReportTypes.EnrolledGiftsReport
                                && <EnrolledGiftsReport handleCancel={this.handleCancel} />}
                            {this.state.report === ReportTypes.CrossTerritorySalesReport
                                && <CrossTerritorySalesReport handleCancel={this.handleCancel} />}
                        </div>
                    </div>
                </div>
            </div>
        </Container>
    }
}

export default GiftReport